jQuery(document).ready(function(){
    jQuery('#check-menu').click(function(){
        jQuery("body, html").toggleClass('hidden');
    });
    jQuery('.menu > li a').click(function(){
        jQuery('#check-menu').prop('checked', false);
        jQuery("body, html").toggleClass('hidden');
    });
    OpenBox({
        wrap: '.open-wrap',
        link: '.drop-btn',
        box: '.open-drop',
        openClass: 'open'
    });
    openClose();
    jQuery('.news-slider').slick({
        slidesToShow: 3,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 720,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    variableWidth: true,
                    centerMode: true
                }
            }
        ]
    });
});

function OpenBox(obj){
    jQuery(obj.wrap).each(function(){
        var hold = jQuery(this);
        var link = hold.find(obj.link);
        var box = hold.find(obj.box);
        var w = obj.w;
        var close = hold.find(obj.close);

        link.click(function(){
            jQuery(obj.wrap).not(hold).removeClass(obj.openClass);
            if (!hold.hasClass(obj.openClass)) {
                hold.addClass(obj.openClass);
            }
            else {
                hold.removeClass(obj.openClass);
            }
            return false;
        });
        hold.hover(function(){
            jQuery(this).addClass('hovering');
        }, function(){
            jQuery(this).removeClass('hovering');
        });
        jQuery("body").click(function(){
            if (!hold.hasClass('hovering')) {
                hold.removeClass(obj.openClass);
            }
        });
        close.click(function(){
            hold.removeClass(obj.openClass);
            return false;
        });
        jQuery(document).bind('touchstart mousedown', function(e){
            if(!(jQuery(e.target).parents().index(hold) != -1 || jQuery(e.target).index(hold) != -1)){
                hold.removeClass(obj.openClass);
            }
        });
    });
};
function openClose() {
    var wrap = jQuery('.question-hold').each(function () {
        var boxed = jQuery(this);
        var link = boxed.find('.question-title, .arrow-btn');
        var boxOpen = boxed.find('.question-drop');

        boxOpen.css('display', 'none');
        boxed.removeClass('open')
        link.on('click', function (e) {
            if (!boxed.hasClass('open')) {
                boxed.addClass('open');
                boxOpen.slideUp(0).slideDown(400);
            }
            else {
                boxOpen.slideUp(400, function () {
                    boxed.removeClass('open');
                });
            }
            return false;
        });
    });
};